const PARAM = 'pseudo-locale';
const STORAGE_KEY = 'dh:pseudo-locale';

/**
 * `?pseudo-locale=1` turns pseudo-locale on for the tab (sessionStorage), `?pseudo-locale=0`
 * turns it off. While on, every `t()` and dashing-ui message renders as `⟦…⟧`, so any
 * unwrapped text on screen has not been extracted yet.
 */
export function resolvePseudoLocale(
  search: string,
  storage: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>,
) {
  const param = new URLSearchParams(search).get(PARAM);
  try {
    if (param === '1') storage.setItem(STORAGE_KEY, '1');
    else if (param === '0') storage.removeItem(STORAGE_KEY);
    return storage.getItem(STORAGE_KEY) === '1';
  } catch {
    return param === '1';
  }
}

export function pseudoWrap(text: string) {
  return `⟦${text}⟧`;
}

/** Copy of a message tree with every string leaf wrapped; plural forms included. */
export function pseudoMessages<T>(tree: T): T {
  if (typeof tree === 'string') return pseudoWrap(tree) as T;
  if (tree === null || typeof tree !== 'object') return tree;
  return Object.fromEntries(
    Object.entries(tree).map(([key, value]) => [key, pseudoMessages(value)]),
  ) as T;
}

export const pseudoLocale =
  typeof window !== 'undefined' &&
  resolvePseudoLocale(window.location.search, window.sessionStorage);
